import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';

import { AppContext } from '@prisjakt/ui-app-context';

import { Panel, PanelHeader, PanelTitle } from '@prisjakt/ui/panel';
import { bemGenerator } from '@prisjakt/ui-base';
import ForumIcon from 'mdi-react/ForumIcon';
import Button from '@prisjakt/ui-button';
import Topic from './components/forum-topic';

import './index.scss';

const styles = bemGenerator('forum-topic-listing', ['topics', 'forum']);

const ForumTopicListing = ({ topics }) => {
  const { t, market } = useContext(AppContext);

  if (!topics.nodes.length) {
    return null;
  }

  return (
    <Panel>
      <PanelHeader>
        <PanelTitle>{t('footer', 'forum.title')}</PanelTitle>
      </PanelHeader>

      <div className={styles.block}>
        <div className={styles.topics}>
          {topics.nodes.map(topic => (
            <Topic key={topic.id} topic={topic} />
          ))}
        </div>
        {/* eslint-disable-next-line react/jsx-no-target-blank */}
        <a href={market.forum} target="_blank" rel="noopener">
          <div className={styles.forum}>
            <ForumIcon size={60} />
            <Button color="primary">{t('landing', 'forum.go-to')}</Button>
          </div>
        </a>
      </div>
    </Panel>
  );
};

ForumTopicListing.propTypes = {
  topics: PropTypes.shape({
    nodes: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        uri: PropTypes.string,
        title: PropTypes.string,
        lastPost: PropTypes.string,
      })
    ),
  }),
};

ForumTopicListing.defaultProps = {
  topics: {
    nodes: [],
  },
};

export default memo(ForumTopicListing);
